import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  model,
  OnInit,
  output,
  signal,
  ViewChild,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ScrollEndDirective } from '../../directives';

export interface ChipOption {
  title: string;
  value: string | number | null;
}

@Component({
  selector: 'app-chips',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatChipsModule,
    MatIconModule,
    ScrollEndDirective,
  ],
  templateUrl: './chips.component.html',
  styleUrl: './chips.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipsComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport) viewport!: CdkVirtualScrollViewport;

  changed = output<ChipOption[]>();
  loadNext = output<void>();

  options = input.required<ChipOption[]>();
  placeholder = input<string>('');
  label = input<string | null>();
  value = input<ChipOption[]>();

  
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  readonly inputValue = model('');
  selectedItems = signal<ChipOption[]>([]);

  filteredOptions = computed(() => {
    const options = this.options();
    const query = this.inputValue();
    const selected = this.selectedItems();

    const filteredByChips = selected.length
      ? options.filter(
          (option) => !selected.some((item) => item.value === option.value)
        )
      : options;

    return query
      ? filteredByChips.filter((item) =>
          item.title?.toLowerCase().includes(query.toLowerCase())
        )
      : filteredByChips;
  });

  ngOnInit(): void {
    this.selectedItems.set(this.value() ?? []);
  }

  remove(value: string | number | null): void {
    this.selectedItems.update((items) => {
      return items.filter((item) => item.value !== value);
    });
    this.changed.emit(this.selectedItems());
  }

  selectOption(value: ChipOption): void {
    this.selectedItems.update((items) => [...items, value]);
    this.changed.emit(this.selectedItems());
    this.inputValue.set('');
  }
}
